// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23122048%27%3E%3Cpath d=%27M13 4L6.5 11 3 7.5%27 stroke=%27%23122048%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
       Becker Taiwan — CIA Page Styles
       Scoped to .becker-cia-page — no root/global overrides
       ============================================================ */
.becker-cia-page {
  --becker-yellow: #FDC20D;
  --becker-blue: #122048;
  --becker-raspberry: #B01F5D;
  --becker-backup-blue: #0A4B77;
  --becker-teal: #4896A2;
  --becker-cyan: #9AC6C7;
  --becker-gray-dark: #4A4A4A;
  --becker-gray-light: #F4F4F4;
  --becker-white: #FFFFFF;
  /* Theme: Cool Gray 11 as main, White & Yellow as support */
  --bg-page: #F4F4F4;
  --bg-card: #FFFFFF;
  --bg-hero: #4A4A4A;
  --bg-section-alt: #EFEFEF;
  --text-primary: #4A4A4A;
  --text-heading: #122048;
  --text-muted: #6B6B6B;
  --text-on-dark: #FFFFFF;
  --accent: #FDC20D;
  --accent-dark: #c99800;
  --border: #DCDCDC;
  font-family: "Open Sans", "Noto Sans TC", sans-serif;
  font-weight: 400;
  color: var(--text-primary);
  background-color: var(--bg-page);
  line-height: 1.75;
  -webkit-font-smoothing: antialiased;
}

/* Reset inside scope */
.becker-cia-page *, .becker-cia-page *::before, .becker-cia-page *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.becker-cia-page img {
  max-width: 100%;
  display: block;
}

.becker-cia-page a {
  color: var(--becker-backup-blue);
  text-decoration: none;
}

.becker-cia-page a:hover {
  text-decoration: underline;
}

.becker-cia-page ul {
  list-style: none;
}

/* ---- Layout ---- */
.becker-cia-page .cia-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ---- HEADER / NAV ---- */
.becker-cia-page .cia-header {
  background: var(--becker-blue);
  padding: 18px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 3px solid var(--accent);
}

.becker-cia-page .cia-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
}

.becker-cia-page .cia-logo-placeholder {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-on-dark);
}

.becker-cia-page .cia-logo-placeholder .logo-img {
  width: 120px;
  height: 36px;
  background: var(--accent);
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: var(--becker-blue);
  letter-spacing: 0.04em;
}

.becker-cia-page .cia-header-badge {
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* ---- HERO ---- */
.becker-cia-page .cia-hero {
  background: var(--bg-hero);
  padding: 64px 0 56px;
  position: relative;
  overflow: hidden;
}

.becker-cia-page .cia-hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--accent);
}

.becker-cia-page .cia-hero::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: -40px;
  width: 320px;
  height: 100%;
  background: rgba(253, 194, 13, 0.05);
  transform: skewX(-12deg);
  pointer-events: none;
}

.becker-cia-page .cia-hero-eyebrow {
  display: inline-block;
  background: var(--accent);
  color: var(--becker-blue);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 2px;
  margin-bottom: 20px;
}

.becker-cia-page .cia-hero h1 {
  font-size: clamp(24px, 4vw, 36px);
  font-weight: 600;
  color: var(--text-on-dark);
  line-height: 1.3;
  margin-bottom: 16px;
  max-width: 680px;
}

.becker-cia-page .cia-hero-subtitle {
  font-size: 15px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.75);
  max-width: 580px;
  line-height: 1.7;
  margin-bottom: 32px;
}

.becker-cia-page .cia-hero-stats {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}

.becker-cia-page .cia-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.becker-cia-page .cia-stat-number {
  font-size: 26px;
  font-weight: 700;
  color: var(--accent);
  line-height: 1;
}

.becker-cia-page .cia-stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 300;
}

/* ---- CONTENT AREA ---- */
.becker-cia-page .cia-body {
  padding: 48px 0 80px;
}

/* ---- SECTION ---- */
.becker-cia-page .cia-section {
  margin-bottom: 56px;
}

.becker-cia-page .cia-section-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-heading);
  padding-bottom: 10px;
  border-bottom: 2px solid var(--accent);
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.becker-cia-page .cia-section-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: var(--becker-blue);
  color: var(--accent);
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.becker-cia-page .cia-section-sub {
  font-size: 16px;
  font-weight: 600;
  color: var(--becker-blue);
  margin: 28px 0 12px;
}

.becker-cia-page .cia-prose {
  font-size: 15px;
  line-height: 1.85;
  color: var(--text-primary);
  font-weight: 300;
  margin-bottom: 14px;
}

/* ---- INFO BOX (value proposition) ---- */
.becker-cia-page .cia-infobox {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-left: 4px solid var(--accent);
  border-radius: 4px;
  padding: 20px 24px;
  margin: 20px 0;
}

.becker-cia-page .cia-infobox p {
  font-size: 14px;
  font-weight: 300;
  color: var(--text-muted);
  line-height: 1.7;
}

.becker-cia-page .cia-infobox p + p {
  margin-top: 8px;
}

/* ---- SALARY CALLOUT ---- */
.becker-cia-page .cia-salary-banner {
  background: var(--becker-blue);
  border-radius: 6px;
  padding: 28px 32px;
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
  margin: 20px 0;
}

.becker-cia-page .cia-salary-number {
  font-size: 48px;
  font-weight: 700;
  color: var(--accent);
  line-height: 1;
  white-space: nowrap;
}

.becker-cia-page .cia-salary-desc {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.becker-cia-page .cia-salary-desc strong {
  font-weight: 600;
  color: var(--text-on-dark);
}

/* ---- EXAM PARTS GRID ---- */
.becker-cia-page .cia-parts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin: 20px 0;
}

.becker-cia-page .cia-part-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.becker-cia-page .cia-part-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--accent);
}

.becker-cia-page .cia-part-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 6px;
}

.becker-cia-page .cia-part-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-heading);
  margin-bottom: 12px;
}

.becker-cia-page .cia-part-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.becker-cia-page .cia-tag {
  font-size: 11px;
  font-weight: 400;
  color: var(--becker-backup-blue);
  background: #E8F1F7;
  border-radius: 2px;
  padding: 3px 8px;
}

.becker-cia-page .cia-tag-highlight {
  background: rgba(253, 194, 13, 0.18);
  color: #7a5d00;
}

/* ---- CHECKLIST ---- */
.becker-cia-page .cia-checklist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 14px 0;
}

.becker-cia-page .cia-checklist li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  font-weight: 300;
  color: var(--text-primary);
  line-height: 1.6;
}

.becker-cia-page .cia-checklist li::before {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  min-width: 16px;
  background: var(--accent);
  border-radius: 50%;
  margin-top: 3px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: center;
}

/* ---- FLOW STEPS ---- */
.becker-cia-page .cia-steps {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 20px 0;
}

.becker-cia-page .cia-step {
  display: flex;
  gap: 16px;
  position: relative;
}

.becker-cia-page .cia-step-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 36px;
  flex-shrink: 0;
}

.becker-cia-page .cia-step-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--becker-blue);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  z-index: 1;
}

.becker-cia-page .cia-step-line {
  width: 2px;
  flex: 1 1;
  background: var(--border);
  margin: 2px 0;
}

.becker-cia-page .cia-step:last-child .cia-step-line {
  display: none;
}

.becker-cia-page .cia-step-body {
  padding: 6px 0 24px;
  flex: 1 1;
}

.becker-cia-page .cia-step-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-heading);
  margin-bottom: 4px;
}

.becker-cia-page .cia-step-desc {
  font-size: 13px;
  font-weight: 300;
  color: var(--text-muted);
  line-height: 1.6;
}

/* ---- CHALLENGE EXAM HIGHLIGHT ---- */
.becker-cia-page .cia-challenge-box {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 6px;
  overflow: hidden;
  margin: 20px 0;
}

.becker-cia-page .cia-challenge-header {
  background: var(--becker-blue);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.becker-cia-page .cia-challenge-header h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-on-dark);
}

.becker-cia-page .cia-challenge-badge {
  background: var(--accent);
  color: var(--becker-blue);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 2px;
}

.becker-cia-page .cia-challenge-body {
  padding: 20px 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.becker-cia-page .cia-challenge-col-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 10px;
}

/* ---- EXAM FORMAT TABLE ---- */
.becker-cia-page .cia-format-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 14px 0;
}

.becker-cia-page .cia-format-item {
  background: var(--bg-section-alt);
  border-radius: 4px;
  padding: 12px 16px;
}

.becker-cia-page .cia-format-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.becker-cia-page .cia-format-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-heading);
}

/* ---- PRODUCT SECTION ---- */
.becker-cia-page .cia-product-section {
  background: var(--becker-blue);
  border-radius: 8px;
  padding: 40px 36px;
  margin: 20px 0;
}

.becker-cia-page .cia-product-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-on-dark);
  margin-bottom: 8px;
}

.becker-cia-page .cia-product-sub {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 28px;
}

.becker-cia-page .cia-features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 14px;
  margin-bottom: 28px;
}

.becker-cia-page .cia-feature-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  padding: 14px 16px;
}

.becker-cia-page .cia-feature-icon {
  width: 28px;
  height: 28px;
  background: var(--accent);
  border-radius: 3px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.becker-cia-page .cia-feature-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-on-dark);
  margin-bottom: 3px;
}

.becker-cia-page .cia-feature-desc {
  font-size: 12px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
}

.becker-cia-page .cia-plans-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.becker-cia-page .cia-plan-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.becker-cia-page .cia-plan-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-on-dark);
}

.becker-cia-page .cia-plan-desc {
  font-size: 12px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
}

.becker-cia-page .cia-plan-link {
  display: inline-block;
  background: var(--accent);
  color: var(--becker-blue);
  font-size: 12px;
  font-weight: 700;
  padding: 7px 14px;
  border-radius: 2px;
  text-decoration: none;
  align-self: flex-start;
}

.becker-cia-page .cia-plan-link:hover {
  background: #ffd444;
  text-decoration: none;
}

/* ---- CONCLUSION ---- */
.becker-cia-page .cia-conclusion {
  background: var(--bg-section-alt);
  border-radius: 6px;
  border: 1px solid var(--border);
  padding: 28px 32px;
  margin: 20px 0;
}

.becker-cia-page .cia-conclusion p {
  font-size: 14px;
  font-weight: 300;
  color: var(--text-primary);
  line-height: 1.8;
}

.becker-cia-page .cia-conclusion p + p {
  margin-top: 12px;
}

/* ---- TABLE of qualifications ---- */
.becker-cia-page .cia-table-wrapper {
  overflow-x: auto;
  margin: 16px 0;
}

.becker-cia-page .cia-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.becker-cia-page .cia-table th {
  background: var(--becker-blue);
  color: var(--accent);
  font-weight: 600;
  padding: 10px 14px;
  text-align: left;
  white-space: nowrap;
}

.becker-cia-page .cia-table td {
  padding: 10px 14px;
  border-bottom: 1px solid var(--border);
  font-weight: 300;
  color: var(--text-primary);
  vertical-align: top;
}

.becker-cia-page .cia-table tr:last-child td {
  border-bottom: none;
}

.becker-cia-page .cia-table tr:nth-child(even) td {
  background: var(--bg-section-alt);
}

/* ---- RESPONSIVE ---- */
@media (max-width: 600px) {
  .becker-cia-page .cia-hero {
    padding: 40px 0 36px;
  }
  .becker-cia-page .cia-hero h1 {
    font-size: 22px;
  }
  .becker-cia-page .cia-hero-stats {
    gap: 20px;
  }
  .becker-cia-page .cia-stat-number {
    font-size: 20px;
  }
  .becker-cia-page .cia-salary-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 20px 20px;
  }
  .becker-cia-page .cia-salary-number {
    font-size: 36px;
  }
  .becker-cia-page .cia-challenge-body {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .becker-cia-page .cia-format-grid {
    grid-template-columns: 1fr 1fr;
  }
  .becker-cia-page .cia-plans-row {
    grid-template-columns: 1fr;
  }
  .becker-cia-page .cia-product-section {
    padding: 28px 20px;
  }
  .becker-cia-page .cia-section-title {
    font-size: 17px;
  }
  .becker-cia-page .cia-body {
    padding: 32px 0 56px;
  }
  .becker-cia-page .cia-conclusion {
    padding: 20px;
  }
}
@media (max-width: 420px) {
  .becker-cia-page .cia-parts-grid {
    grid-template-columns: 1fr;
  }
  .becker-cia-page .cia-features-grid {
    grid-template-columns: 1fr;
  }
  .becker-cia-page .cia-format-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cia/styles/cia.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;qEAAA;AAKI;EACE,wBAAA;EACA,sBAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,uBAAA;EAEA,2DAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EAEA,oDAAA;EACA,gBAAA;EACA,0BAAA;EACA,gCAAA;EACA,iBAAA;EACA,mCAAA;AADN;;AAII,uBAAA;AACA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AADN;;AAII;EAAuB,eAAA;EAAiB,cAAA;AAC5C;;AAAI;EAAqB,gCAAA;EAAkC,qBAAA;AAK3D;;AAJI;EAA2B,0BAAA;AAQ/B;;AAPI;EAAsB,gBAAA;AAW1B;;AATI,qBAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAYN;;AATI,2BAAA;AACA;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,sCAAA;AAYN;;AATI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAYN;;AATI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;AAYN;;AATI;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAYN;;AATI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;AAYN;;AATI,mBAAA;AACA;EACE,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAYN;;AATI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EAAQ,OAAA;EAAS,QAAA;EACjB,WAAA;EACA,yBAAA;AAcN;;AAXI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EAAc,YAAA;EACd,YAAA;EACA,YAAA;EACA,oCAAA;EACA,wBAAA;EACA,oBAAA;AAeN;;AAZI;EACE,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAeN;;AAZI;EACE,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAeN;;AAZI;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAeN;;AAZI;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAeN;;AAZI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAeN;;AAZI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAeN;;AAZI;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAeN;;AAZI,2BAAA;AACA;EACE,oBAAA;AAeN;;AAZI,sBAAA;AACA;EACE,mBAAA;AAeN;;AAZI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAeN;;AAZI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAeN;;AAZI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAeN;;AAZI;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AAeN;;AAZI,2CAAA;AACA;EACE,0BAAA;EACA,+BAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAeN;;AAZI;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AAeN;;AAZI;EAAsC,eAAA;AAgB1C;;AAdI,6BAAA;AACA;EACE,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAiBN;;AAdI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AAiBN;;AAdI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;AAiBN;;AAdI;EACE,gBAAA;EACA,0BAAA;AAiBN;;AAdI,8BAAA;AACA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,cAAA;AAiBN;;AAdI;EACE,0BAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAiBN;;AAdI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EAAQ,OAAA;EAAS,QAAA;EACjB,WAAA;EACA,yBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAmBN;;AAhBI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAmBN;;AAhBI;EACE,oCAAA;EACA,cAAA;AAmBN;;AAhBI,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AAmBN;;AAhBI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yDAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AAmBN;;AAhBI,yBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAmBN;;AAhBI;EACE,UAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAmBN;;AAhBI;EACE,aAAA;AAmBN;;AAhBI;EACE,mBAAA;EACA,SAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AAmBN;;AAhBI,uCAAA;AACA;EACE,0BAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AAmBN;;AAhBI;EACE,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;AAmBN;;AAhBI,gCAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,iCAAA;EACA,kBAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AAmBN;;AAhBI,8BAAA;AACA;EACE,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AAmBN;;AAhBI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAmBN;;AAhBI;EACE,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;AAmBN;;AAhBI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAmBN;;AAhBI;EACE,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;AAmBN;;AAhBI;EACE,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAmBN;;AAhBI;EACE,mBAAA;EACA,qBAAA;AAmBN;;AAhBI,yBAAA;AACA;EACE,iCAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;AAmBN;;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AAmBN;;AAhBI;EACE,gBAAA;AAmBN;;AAdI,sCAAA;AACA;EACE,gBAAA;EACA,cAAA;AAiBN;;AAdI;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAiBN;;AAdI;EACE,8BAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAiBN;;AAdI;EACE,kBAAA;EACA,sCAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAiBN;;AAdI;EACE,mBAAA;AAiBN;;AAdI;EACE,iCAAA;AAiBN;;AAdI,yBAAA;AACA;EACE;IACE,oBAAA;EAiBN;EAdI;IACE,eAAA;EAgBN;EAbI;IACE,SAAA;EAeN;EAZI;IACE,eAAA;EAcN;EAXI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;EAaN;EAVI;IACE,eAAA;EAYN;EATI;IACE,0BAAA;IACA,SAAA;EAWN;EARI;IACE,8BAAA;EAUN;EAPI;IACE,0BAAA;EASN;EANI;IACE,kBAAA;EAQN;EALI;IACE,eAAA;EAON;EAJI;IACE,oBAAA;EAMN;EAHI;IACE,aAAA;EAKN;AACF;AAFI;EACE;IACE,0BAAA;EAIN;EAFI;IACE,0BAAA;EAIN;EAFI;IACE,0BAAA;EAIN;AACF","sourcesContent":["/* ============================================================\r\n       Becker Taiwan — CIA Page Styles\r\n       Scoped to .becker-cia-page — no root/global overrides\r\n       ============================================================ */\r\n    \r\n    .becker-cia-page {\r\n      --becker-yellow: #FDC20D;\r\n      --becker-blue: #122048;\r\n      --becker-raspberry: #B01F5D;\r\n      --becker-backup-blue: #0A4B77;\r\n      --becker-teal: #4896A2;\r\n      --becker-cyan: #9AC6C7;\r\n      --becker-gray-dark: #4A4A4A;\r\n      --becker-gray-light: #F4F4F4;\r\n      --becker-white: #FFFFFF;\r\n    \r\n      /* Theme: Cool Gray 11 as main, White & Yellow as support */\r\n      --bg-page: #F4F4F4;\r\n      --bg-card: #FFFFFF;\r\n      --bg-hero: #4A4A4A;\r\n      --bg-section-alt: #EFEFEF;\r\n      --text-primary: #4A4A4A;\r\n      --text-heading: #122048;\r\n      --text-muted: #6B6B6B;\r\n      --text-on-dark: #FFFFFF;\r\n      --accent: #FDC20D;\r\n      --accent-dark: #c99800;\r\n      --border: #DCDCDC;\r\n    \r\n      font-family: 'Open Sans', 'Noto Sans TC', sans-serif;\r\n      font-weight: 400;\r\n      color: var(--text-primary);\r\n      background-color: var(--bg-page);\r\n      line-height: 1.75;\r\n      -webkit-font-smoothing: antialiased;\r\n    }\r\n    \r\n    /* Reset inside scope */\r\n    .becker-cia-page *, .becker-cia-page *::before, .becker-cia-page *::after {\r\n      box-sizing: border-box;\r\n      margin: 0;\r\n      padding: 0;\r\n    }\r\n    \r\n    .becker-cia-page img { max-width: 100%; display: block; }\r\n    .becker-cia-page a { color: var(--becker-backup-blue); text-decoration: none; }\r\n    .becker-cia-page a:hover { text-decoration: underline; }\r\n    .becker-cia-page ul { list-style: none; }\r\n    \r\n    /* ---- Layout ---- */\r\n    .becker-cia-page .cia-container {\r\n      max-width: 900px;\r\n      margin: 0 auto;\r\n      padding: 0 24px;\r\n    }\r\n    \r\n    /* ---- HEADER / NAV ---- */\r\n    .becker-cia-page .cia-header {\r\n      background: var(--becker-blue);\r\n      padding: 18px 0;\r\n      position: sticky;\r\n      top: 0;\r\n      z-index: 100;\r\n      border-bottom: 3px solid var(--accent);\r\n    }\r\n    \r\n    .becker-cia-page .cia-header-inner {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      max-width: 900px;\r\n      margin: 0 auto;\r\n      padding: 0 24px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-logo-placeholder {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      color: var(--text-on-dark);\r\n    }\r\n    \r\n    .becker-cia-page .cia-logo-placeholder .logo-img {\r\n      width: 120px;\r\n      height: 36px;\r\n      background: var(--accent);\r\n      border-radius: 3px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      font-size: 13px;\r\n      font-weight: 700;\r\n      color: var(--becker-blue);\r\n      letter-spacing: 0.04em;\r\n    }\r\n    \r\n    .becker-cia-page .cia-header-badge {\r\n      font-size: 12px;\r\n      font-weight: 600;\r\n      color: var(--accent);\r\n      letter-spacing: 0.08em;\r\n      text-transform: uppercase;\r\n    }\r\n    \r\n    /* ---- HERO ---- */\r\n    .becker-cia-page .cia-hero {\r\n      background: var(--bg-hero);\r\n      padding: 64px 0 56px;\r\n      position: relative;\r\n      overflow: hidden;\r\n    }\r\n    \r\n    .becker-cia-page .cia-hero::before {\r\n      content: '';\r\n      position: absolute;\r\n      top: 0; left: 0; right: 0;\r\n      height: 4px;\r\n      background: var(--accent);\r\n    }\r\n    \r\n    .becker-cia-page .cia-hero::after {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: -1px; right: -40px;\r\n      width: 320px;\r\n      height: 100%;\r\n      background: rgba(253, 194, 13, 0.05);\r\n      transform: skewX(-12deg);\r\n      pointer-events: none;\r\n    }\r\n    \r\n    .becker-cia-page .cia-hero-eyebrow {\r\n      display: inline-block;\r\n      background: var(--accent);\r\n      color: var(--becker-blue);\r\n      font-size: 11px;\r\n      font-weight: 700;\r\n      letter-spacing: 0.1em;\r\n      text-transform: uppercase;\r\n      padding: 4px 12px;\r\n      border-radius: 2px;\r\n      margin-bottom: 20px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-hero h1 {\r\n      font-size: clamp(24px, 4vw, 36px);\r\n      font-weight: 600;\r\n      color: var(--text-on-dark);\r\n      line-height: 1.3;\r\n      margin-bottom: 16px;\r\n      max-width: 680px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-hero-subtitle {\r\n      font-size: 15px;\r\n      font-weight: 300;\r\n      color: rgba(255,255,255,0.75);\r\n      max-width: 580px;\r\n      line-height: 1.7;\r\n      margin-bottom: 32px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-hero-stats {\r\n      display: flex;\r\n      gap: 32px;\r\n      flex-wrap: wrap;\r\n    }\r\n    \r\n    .becker-cia-page .cia-stat {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 2px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-stat-number {\r\n      font-size: 26px;\r\n      font-weight: 700;\r\n      color: var(--accent);\r\n      line-height: 1;\r\n    }\r\n    \r\n    .becker-cia-page .cia-stat-label {\r\n      font-size: 12px;\r\n      color: rgba(255,255,255,0.65);\r\n      font-weight: 300;\r\n    }\r\n    \r\n    /* ---- CONTENT AREA ---- */\r\n    .becker-cia-page .cia-body {\r\n      padding: 48px 0 80px;\r\n    }\r\n    \r\n    /* ---- SECTION ---- */\r\n    .becker-cia-page .cia-section {\r\n      margin-bottom: 56px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-section-title {\r\n      font-size: 20px;\r\n      font-weight: 600;\r\n      color: var(--text-heading);\r\n      padding-bottom: 10px;\r\n      border-bottom: 2px solid var(--accent);\r\n      margin-bottom: 24px;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-section-num {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: 26px;\r\n      height: 26px;\r\n      background: var(--becker-blue);\r\n      color: var(--accent);\r\n      border-radius: 50%;\r\n      font-size: 12px;\r\n      font-weight: 700;\r\n      flex-shrink: 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-section-sub {\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n      color: var(--becker-blue);\r\n      margin: 28px 0 12px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-prose {\r\n      font-size: 15px;\r\n      line-height: 1.85;\r\n      color: var(--text-primary);\r\n      font-weight: 300;\r\n      margin-bottom: 14px;\r\n    }\r\n    \r\n    /* ---- INFO BOX (value proposition) ---- */\r\n    .becker-cia-page .cia-infobox {\r\n      background: var(--bg-card);\r\n      border: 1px solid var(--border);\r\n      border-left: 4px solid var(--accent);\r\n      border-radius: 4px;\r\n      padding: 20px 24px;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-infobox p {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      color: var(--text-muted);\r\n      line-height: 1.7;\r\n    }\r\n    \r\n    .becker-cia-page .cia-infobox p + p { margin-top: 8px; }\r\n    \r\n    /* ---- SALARY CALLOUT ---- */\r\n    .becker-cia-page .cia-salary-banner {\r\n      background: var(--becker-blue);\r\n      border-radius: 6px;\r\n      padding: 28px 32px;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 28px;\r\n      flex-wrap: wrap;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-salary-number {\r\n      font-size: 48px;\r\n      font-weight: 700;\r\n      color: var(--accent);\r\n      line-height: 1;\r\n      white-space: nowrap;\r\n    }\r\n    \r\n    .becker-cia-page .cia-salary-desc {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      color: rgba(255,255,255,0.8);\r\n      line-height: 1.6;\r\n    }\r\n    \r\n    .becker-cia-page .cia-salary-desc strong {\r\n      font-weight: 600;\r\n      color: var(--text-on-dark);\r\n    }\r\n    \r\n    /* ---- EXAM PARTS GRID ---- */\r\n    .becker-cia-page .cia-parts-grid {\r\n      display: grid;\r\n      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n      gap: 16px;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-part-card {\r\n      background: var(--bg-card);\r\n      border: 1px solid var(--border);\r\n      border-radius: 6px;\r\n      padding: 20px;\r\n      position: relative;\r\n      overflow: hidden;\r\n    }\r\n    \r\n    .becker-cia-page .cia-part-card::before {\r\n      content: '';\r\n      position: absolute;\r\n      top: 0; left: 0; right: 0;\r\n      height: 3px;\r\n      background: var(--accent);\r\n    }\r\n    \r\n    .becker-cia-page .cia-part-label {\r\n      font-size: 11px;\r\n      font-weight: 700;\r\n      letter-spacing: 0.1em;\r\n      text-transform: uppercase;\r\n      color: var(--text-muted);\r\n      margin-bottom: 6px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-part-title {\r\n      font-size: 15px;\r\n      font-weight: 600;\r\n      color: var(--text-heading);\r\n      margin-bottom: 12px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-part-tags {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 6px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-tag {\r\n      font-size: 11px;\r\n      font-weight: 400;\r\n      color: var(--becker-backup-blue);\r\n      background: #E8F1F7;\r\n      border-radius: 2px;\r\n      padding: 3px 8px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-tag-highlight {\r\n      background: rgba(253, 194, 13, 0.18);\r\n      color: #7a5d00;\r\n    }\r\n    \r\n    /* ---- CHECKLIST ---- */\r\n    .becker-cia-page .cia-checklist {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 10px;\r\n      margin: 14px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-checklist li {\r\n      display: flex;\r\n      align-items: flex-start;\r\n      gap: 12px;\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      color: var(--text-primary);\r\n      line-height: 1.6;\r\n    }\r\n    \r\n    .becker-cia-page .cia-checklist li::before {\r\n      content: '';\r\n      display: block;\r\n      width: 16px;\r\n      height: 16px;\r\n      min-width: 16px;\r\n      background: var(--accent);\r\n      border-radius: 50%;\r\n      margin-top: 3px;\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23122048'%3E%3Cpath d='M13 4L6.5 11 3 7.5' stroke='%23122048' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E\");\r\n      background-size: 10px;\r\n      background-repeat: no-repeat;\r\n      background-position: center;\r\n    }\r\n    \r\n    /* ---- FLOW STEPS ---- */\r\n    .becker-cia-page .cia-steps {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step {\r\n      display: flex;\r\n      gap: 16px;\r\n      position: relative;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step-left {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      width: 36px;\r\n      flex-shrink: 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step-dot {\r\n      width: 36px;\r\n      height: 36px;\r\n      border-radius: 50%;\r\n      background: var(--becker-blue);\r\n      color: var(--accent);\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      font-size: 13px;\r\n      font-weight: 700;\r\n      flex-shrink: 0;\r\n      z-index: 1;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step-line {\r\n      width: 2px;\r\n      flex: 1;\r\n      background: var(--border);\r\n      margin: 2px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step:last-child .cia-step-line {\r\n      display: none;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step-body {\r\n      padding: 6px 0 24px;\r\n      flex: 1;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step-title {\r\n      font-size: 14px;\r\n      font-weight: 600;\r\n      color: var(--text-heading);\r\n      margin-bottom: 4px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-step-desc {\r\n      font-size: 13px;\r\n      font-weight: 300;\r\n      color: var(--text-muted);\r\n      line-height: 1.6;\r\n    }\r\n    \r\n    /* ---- CHALLENGE EXAM HIGHLIGHT ---- */\r\n    .becker-cia-page .cia-challenge-box {\r\n      background: var(--bg-card);\r\n      border: 1px solid var(--border);\r\n      border-radius: 6px;\r\n      overflow: hidden;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-challenge-header {\r\n      background: var(--becker-blue);\r\n      padding: 16px 24px;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 12px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-challenge-header h3 {\r\n      font-size: 15px;\r\n      font-weight: 600;\r\n      color: var(--text-on-dark);\r\n    }\r\n    \r\n    .becker-cia-page .cia-challenge-badge {\r\n      background: var(--accent);\r\n      color: var(--becker-blue);\r\n      font-size: 10px;\r\n      font-weight: 700;\r\n      letter-spacing: 0.08em;\r\n      text-transform: uppercase;\r\n      padding: 3px 8px;\r\n      border-radius: 2px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-challenge-body {\r\n      padding: 20px 24px;\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 24px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-challenge-col-title {\r\n      font-size: 11px;\r\n      font-weight: 700;\r\n      letter-spacing: 0.08em;\r\n      text-transform: uppercase;\r\n      color: var(--text-muted);\r\n      margin-bottom: 10px;\r\n    }\r\n    \r\n    /* ---- EXAM FORMAT TABLE ---- */\r\n    .becker-cia-page .cia-format-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 10px;\r\n      margin: 14px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-format-item {\r\n      background: var(--bg-section-alt);\r\n      border-radius: 4px;\r\n      padding: 12px 16px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-format-label {\r\n      font-size: 11px;\r\n      font-weight: 700;\r\n      letter-spacing: 0.06em;\r\n      text-transform: uppercase;\r\n      color: var(--text-muted);\r\n      margin-bottom: 4px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-format-value {\r\n      font-size: 15px;\r\n      font-weight: 600;\r\n      color: var(--text-heading);\r\n    }\r\n    \r\n    /* ---- PRODUCT SECTION ---- */\r\n    .becker-cia-page .cia-product-section {\r\n      background: var(--becker-blue);\r\n      border-radius: 8px;\r\n      padding: 40px 36px;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-product-title {\r\n      font-size: 20px;\r\n      font-weight: 600;\r\n      color: var(--text-on-dark);\r\n      margin-bottom: 8px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-product-sub {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      color: rgba(255,255,255,0.7);\r\n      margin-bottom: 28px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-features-grid {\r\n      display: grid;\r\n      grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n      gap: 14px;\r\n      margin-bottom: 28px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-feature-card {\r\n      background: rgba(255,255,255,0.06);\r\n      border: 1px solid rgba(255,255,255,0.12);\r\n      border-radius: 4px;\r\n      padding: 14px 16px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-feature-icon {\r\n      width: 28px;\r\n      height: 28px;\r\n      background: var(--accent);\r\n      border-radius: 3px;\r\n      margin-bottom: 8px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n    \r\n    .becker-cia-page .cia-feature-name {\r\n      font-size: 13px;\r\n      font-weight: 600;\r\n      color: var(--text-on-dark);\r\n      margin-bottom: 3px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-feature-desc {\r\n      font-size: 12px;\r\n      font-weight: 300;\r\n      color: rgba(255,255,255,0.6);\r\n      line-height: 1.5;\r\n    }\r\n    \r\n    .becker-cia-page .cia-plans-row {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 14px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-plan-card {\r\n      background: rgba(255,255,255,0.08);\r\n      border: 1px solid rgba(255,255,255,0.15);\r\n      border-radius: 4px;\r\n      padding: 18px 20px;\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-plan-name {\r\n      font-size: 13px;\r\n      font-weight: 600;\r\n      color: var(--text-on-dark);\r\n    }\r\n    \r\n    .becker-cia-page .cia-plan-desc {\r\n      font-size: 12px;\r\n      font-weight: 300;\r\n      color: rgba(255,255,255,0.6);\r\n      line-height: 1.5;\r\n    }\r\n    \r\n    .becker-cia-page .cia-plan-link {\r\n      display: inline-block;\r\n      background: var(--accent);\r\n      color: var(--becker-blue);\r\n      font-size: 12px;\r\n      font-weight: 700;\r\n      padding: 7px 14px;\r\n      border-radius: 2px;\r\n      text-decoration: none;\r\n      align-self: flex-start;\r\n    }\r\n    \r\n    .becker-cia-page .cia-plan-link:hover {\r\n      background: #ffd444;\r\n      text-decoration: none;\r\n    }\r\n    \r\n    /* ---- CONCLUSION ---- */\r\n    .becker-cia-page .cia-conclusion {\r\n      background: var(--bg-section-alt);\r\n      border-radius: 6px;\r\n      border: 1px solid var(--border);\r\n      padding: 28px 32px;\r\n      margin: 20px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-conclusion p {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      color: var(--text-primary);\r\n      line-height: 1.8;\r\n    }\r\n    \r\n    .becker-cia-page .cia-conclusion p + p {\r\n      margin-top: 12px;\r\n    }\r\n    \r\n    \r\n    \r\n    /* ---- TABLE of qualifications ---- */\r\n    .becker-cia-page .cia-table-wrapper {\r\n      overflow-x: auto;\r\n      margin: 16px 0;\r\n    }\r\n    \r\n    .becker-cia-page .cia-table {\r\n      width: 100%;\r\n      border-collapse: collapse;\r\n      font-size: 13px;\r\n    }\r\n    \r\n    .becker-cia-page .cia-table th {\r\n      background: var(--becker-blue);\r\n      color: var(--accent);\r\n      font-weight: 600;\r\n      padding: 10px 14px;\r\n      text-align: left;\r\n      white-space: nowrap;\r\n    }\r\n    \r\n    .becker-cia-page .cia-table td {\r\n      padding: 10px 14px;\r\n      border-bottom: 1px solid var(--border);\r\n      font-weight: 300;\r\n      color: var(--text-primary);\r\n      vertical-align: top;\r\n    }\r\n    \r\n    .becker-cia-page .cia-table tr:last-child td {\r\n      border-bottom: none;\r\n    }\r\n    \r\n    .becker-cia-page .cia-table tr:nth-child(even) td {\r\n      background: var(--bg-section-alt);\r\n    }\r\n    \r\n    /* ---- RESPONSIVE ---- */\r\n    @media (max-width: 600px) {\r\n      .becker-cia-page .cia-hero {\r\n        padding: 40px 0 36px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-hero h1 {\r\n        font-size: 22px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-hero-stats {\r\n        gap: 20px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-stat-number {\r\n        font-size: 20px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-salary-banner {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 12px;\r\n        padding: 20px 20px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-salary-number {\r\n        font-size: 36px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-challenge-body {\r\n        grid-template-columns: 1fr;\r\n        gap: 16px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-format-grid {\r\n        grid-template-columns: 1fr 1fr;\r\n      }\r\n    \r\n      .becker-cia-page .cia-plans-row {\r\n        grid-template-columns: 1fr;\r\n      }\r\n    \r\n      .becker-cia-page .cia-product-section {\r\n        padding: 28px 20px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-section-title {\r\n        font-size: 17px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-body {\r\n        padding: 32px 0 56px;\r\n      }\r\n    \r\n      .becker-cia-page .cia-conclusion {\r\n        padding: 20px;\r\n      }\r\n    }\r\n    \r\n    @media (max-width: 420px) {\r\n      .becker-cia-page .cia-parts-grid {\r\n        grid-template-columns: 1fr;\r\n      }\r\n      .becker-cia-page .cia-features-grid {\r\n        grid-template-columns: 1fr;\r\n      }\r\n      .becker-cia-page .cia-format-grid {\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
